import Request from ".";
import { Routes } from "../constant/api_url";

// Get all post types (4 fixed types)
export const getPostTypes = async () => {
  try {
    const result = await Request.get(Routes.GETPOSTTYPES);
    return result?.data;
  } catch (error) {
    throw error;
  }
};

// Create a new role
export const createRole = async (data) => {
  try {
    const result = await Request.post(Routes.CREATEROLE, data, {
      headers: {
        Accept: "application/json, */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

// Update an existing role
export const updateRole = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEROLE, data, {
      headers: {
        Accept: "application/json, */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

// Get roles list with pagination and filters
export const getRoles = async (params) => {
  try {
    const result = await Request.get(Routes.GETROLES, { params });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

// Get role detail by ID
export const getRoleDetail = async (id) => {
  try {
    const result = await Request.get(Routes.GETROLEDETAIL, { params: { id } });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

// Toggle role status (activate/deactivate)
export const toggleRoleStatus = async (data) => {
  try {
    const result = await Request.post(Routes.TOGGLEROLESTATUS, data, {
      headers: {
        Accept: "application/json, */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

// Get full chapter post structure (post types + holders + roles + coordinators)
export const getChapterPostStructure = async (chapterId, postTypeId = null) => {
  try {
    const body = { chapter_id: chapterId };
    if (postTypeId) body.post_type_id = postTypeId;
    const result = await Request.post(Routes.GETCHAPTERPOSTSTRUCTURE, body, {
      headers: {
        Accept: "application/json, */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

// Get members eligible for Self-role assignment in a chapter section
export const getSelfRoleEligibleMembers = async (data) => {
  try {
    const result = await Request.post(Routes.GETSELFROLEELIGIBLEMEMBERS, data, {
      headers: {
        Accept: "application/json, */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

// Get paginated chapter members for coordinator picker
export const getChapterMembers = async (data) => {
  try {
    const result = await Request.post(Routes.GETCHAPTERMEMBERS, data, {
      headers: {
        Accept: "application/json, */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

// Get chapter coordinators by chapter and post type
export const getChapterCoordinators = async (chapterId, postTypeId) => {
  try {
    const result = await Request.post(Routes.GETCHAPTERCOORDINATORS, {
      chapter_id: chapterId,
      post_type_id: postTypeId
    }, {
      headers: {
        Accept: "application/json, */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

// Assign coordinator(s) to a role
export const assignCoordinator = async (data) => {
  try {
    const result = await Request.post(Routes.ASSIGNCOORDINATOR, data, {
      headers: {
        Accept: "application/json, */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

// Remove a coordinator
export const removeCoordinator = async (data) => {
  try {
    const result = await Request.post(Routes.REMOVECOORDINATOR, data, {
      headers: {
        Accept: "application/json, */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

// Get responsibility update history for a role
export const getRoleResponsibilitiesHistory = async (roleId) => {
  try {
    const result = await Request.get(Routes.GETROLERESPONSHISTORY, { params: { role_id: roleId } });
    return result?.data;
  } catch (error) {
    throw error;
  }
};

// Change a coordinator (replace member)
export const changeCoordinator = async (data) => {
  try {
    const result = await Request.post(Routes.CHANGECOORDINATOR, data, {
      headers: {
        Accept: "application/json, */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};
